import { render, staticRenderFns } from "./404.vue?vue&type=template&id=438454d6&scoped=true"
import script from "./404.ts?vue&type=script&lang=ts&external"
export * from "./404.ts?vue&type=script&lang=ts&external"
import style0 from "./404.scoped.scss?vue&type=style&index=0&id=438454d6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438454d6",
  null
  
)

export default component.exports